export const latestAddresses = [
  {
    id: "addr-001",
    url: "https://haijiao-official.com",
    label: "主入口（推荐）",
    status: "active",
    speed: "极速",
    region: "全球",
    updatedAt: "2026-08-07",
    description: "当前最稳定的主入口地址，推荐优先使用，全球节点加速，访问速度极快。",
  },
  {
    id: "addr-002",
    url: "https://haijiao-asia.com",
    label: "亚洲专线",
    status: "active",
    speed: "高速",
    region: "亚洲",
    updatedAt: "2026-08-06",
    description: "亚洲地区专用节点，针对中国大陆及周边地区优化，延迟更低。",
  },
  {
    id: "addr-003",
    url: "https://haijiao-backup.com",
    label: "备用入口",
    status: "active",
    speed: "稳定",
    region: "全球",
    updatedAt: "2026-08-05",
    description: "备用入口地址，当主入口出现波动时可切换至此地址访问。",
  },
  {
    id: "addr-004",
    url: "https://haijiao-europe.com",
    label: "欧洲节点",
    status: "active",
    speed: "高速",
    region: "欧洲",
    updatedAt: "2026-08-04",
    description: "欧洲地区专用节点，覆盖英法德等主要国家，访问流畅稳定。",
  },
];

export const backupAddresses = [
  {
    id: "backup-001",
    url: "https://haijiao-reserve1.com",
    label: "备用地址一",
    status: "standby",
    updatedAt: "2026-08-03",
  },
  {
    id: "backup-002",
    url: "https://haijiao-reserve2.com",
    label: "备用地址二",
    status: "standby",
    updatedAt: "2026-08-02",
  },
  {
    id: "backup-003",
    url: "https://haijiao-mirror.com",
    label: "镜像地址",
    status: "standby",
    updatedAt: "2026-08-01",
  },
];